module.exports = __webpack_public_path__ + "img/home-and-garden.58f3a9085a435f8ba4b05f91f7950d1b.svg";